// custom checkout popup js 
let prodPage = document.querySelector('product-form[data-bw-cart-first]')
let popupBtn = document.querySelectorAll('.customBuynow');
let popupModal = document.querySelector('#PopupModal-customCheckout');
let popupId = document.querySelector('#shopify-section-customCheckoutPopup');
popupBtn.forEach((btn)=>{
  btn.addEventListener('click', () => {
    popupModal.style.display = 'block';
    popupId.style.display = 'block';
  });
})


let customCheckoutButton = document.querySelector('.contentHolder--checkout');
let termsCheckbox = document.querySelector('.contentHolder--terms input');
customCheckoutButton.addEventListener('click', (e) => {
  e.preventDefault();
  if(prodPage && termsCheckbox.checked){
    const button = prodPage.querySelector('[data-bw-cart-first-submit]');
    if (!button || button.disabled) return;
    popupModal.hide();
    popupModal.style.display = 'none';
    popupId.style.display = 'none';
    button.form.requestSubmit(button);
  }else if(termsCheckbox.checked){
    window.location.href= '/checkout'
  }
});
